export const reservationDrawer = {
  title: "Détails de la réservation",
  openFullPage: "Ouvrir en pleine page",
  close: "Fermer",
};
